module.exports = __webpack_public_path__ + "img/dyp12.d6e3a13e.jpg";